import type { ValueOf } from '@weft/utils';

export const PATH_ACCESS_LEVELS: { PUBLIC: PUBLIC_PATH, PRIVATE: PRIVATE_PATH } = Object.freeze({
  PUBLIC: 'public',
  PRIVATE: 'private',
});
export type PRIVATE_PATH = 'private';
export type PUBLIC_PATH = 'public';

export type PathAccessLevel = ValueOf<typeof PATH_ACCESS_LEVELS>;